// extracted by css-extract-rspack-plugin
export default {"item":"Lpkjd_","name":"IrTXnN","img":"bdqXNR"};